import React from "react";
import { Link } from "react-router-dom";
import { BRAND } from "@/lib/brand";
import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";

export default function SiteFooter() {
  return (
    <footer data-testid="site-footer" className="bg-navy text-slate-200 mt-20">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={BRAND.logoUrl} alt="" className="h-12 w-12 object-contain bg-white rounded-xl p-1.5" />
            <div>
              <div className="font-heading font-bold text-white text-lg">Accurate Claims Services</div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-gold">{BRAND.subline}</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-slate-300 leading-relaxed max-w-md">
            An independent claim advisory representing policyholders across Gujarat with documentation,
            dispute resolution and insurance coordination — across health, life, motor and general insurance.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href={BRAND.whatsappUrl} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="btn-emerald !py-2.5 !px-5 text-sm">
              <MessageCircle className="w-4 h-4" /> WhatsApp us
            </a>
            <a href={BRAND.telUrl} data-testid="footer-call" className="text-sm flex items-center gap-2 px-4 py-2.5 rounded-full border border-white/20 hover:bg-white/10 transition-colors">
              <Phone className="w-4 h-4" /> {BRAND.phone}
            </a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="font-heading font-semibold text-white mb-4">Company</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-gold transition-colors">Home</Link></li>
            <li><Link to="/about" className="hover:text-gold transition-colors">About</Link></li>
            <li><Link to="/services" className="hover:text-gold transition-colors">Services</Link></li>
            <li><Link to="/blog" className="hover:text-gold transition-colors">Blog</Link></li>
            <li><Link to="/faq" className="hover:text-gold transition-colors">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-gold transition-colors">Contact</Link></li>
            <li><Link to="/login" className="hover:text-gold transition-colors">Client Portal</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="font-heading font-semibold text-white mb-4">Reach us</div>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-gold shrink-0" />
              <span>
                {BRAND.address.line1}, {BRAND.address.line2}, {BRAND.address.city} - {BRAND.address.pincode}
              </span>
            </li>
            <li className="flex items-center gap-3">
              <Phone className="w-4 h-4 text-gold" />
              <a href={BRAND.telUrl} className="hover:text-gold transition-colors">{BRAND.phoneIntl}</a>
            </li>
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4 text-gold" />
              <a href={BRAND.mailUrl} className="hover:text-gold transition-colors">{BRAND.email}</a>
            </li>
            <li className="text-slate-400 pt-1 text-xs">{BRAND.hours}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Accurate Claims Services. All rights reserved.</div>
          <div className="flex flex-wrap gap-5">
            <a href="#" className="hover:text-gold">Privacy</a>
            <a href="#" className="hover:text-gold">Terms</a>
            <a href="#" className="hover:text-gold">Disclaimer</a>
            <span>An independent claim advisory. We do not sell insurance.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
